export enum AwsSubscriptionType {
  None = 0,
  EndUser = 1, // deprecated
  PAN = 2,
  Marketplace = 4,
}
